import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = [
    'container',
    'panel',
  ]

  connect() {
    useClickOutside(this, { element: this.panelTarget })
  }

  clickOutside() {
    this.closeDrawer()
  }

  openDrawer() {
    enter(this.containerTarget).then(() => {
      enter(this.panelTarget)
    })
  }

  closeDrawer() {
    leave(this.panelTarget).then(() => {
      leave(this.containerTarget)
    })
  }
}
